import { createContext, useContext, useState, useEffect } from "react";

const TerritorioContext = createContext(null);

const VACIO = { territorio: "", comunidad: "" };

export function TerritorioProvider({ children }) {
  const [data, setDataState] = useState(() => {
    try {
      const guardado = localStorage.getItem("territorioData");
      return guardado ? JSON.parse(guardado) : VACIO;
    } catch {
      return VACIO;
    }
  });

  const setData = (nuevo) => {
    setDataState(nuevo);
    try {
      if (nuevo?.territorio) localStorage.setItem("territorioData", JSON.stringify(nuevo));
      else localStorage.removeItem("territorioData");
    } catch { /* noop */ }
  };

  return (
    <TerritorioContext.Provider value={{ data, setData }}>
      {children}
    </TerritorioContext.Provider>
  );
}

export function useTerritorio() {
  const ctx = useContext(TerritorioContext);
  if (!ctx) throw new Error("useTerritorio debe usarse dentro de <TerritorioProvider>");
  return ctx;
}
